import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/Images/Videos/Video-Residential.mp4'
import _imports_1 from '../../../assets/Images/Videos/Video-Investment.mp4'
import _imports_2 from '../../../assets/Images/logo02.png'
import _imports_3 from '../../../assets/Images/arrow-down.svg'
import _imports_4 from '../../../assets/Images/arrow-up.svg'


const _hoisted_1 = { class: "hidden-mobile" }
const _hoisted_2 = { class: "realtors-target" }
const _hoisted_3 = { class: "container-fixed" }
const _hoisted_4 = {
  class: "modal fade",
  id: "modalProducts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "modal-dialog modal-xl" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_1,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "realtors-target__navbar" }
const _hoisted_16 = { class: "navbar navbar-expand-lg d-flex justify-content-between" }
const _hoisted_17 = {
  class: "collapse navbar-collapse d-flex justify-content-between",
  id: "navbarTogglerDemo01"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_19 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_20 = { class: "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center" }
const _hoisted_21 = { class: "nav-item active tw-pr-[40px]" }
const _hoisted_22 = { class: "nav-item active tw-pr-[26px] tw-pl-[2px]" }
const _hoisted_23 = { class: "nav-item active pr-4 tw-relative" }
const _hoisted_24 = { class: "dropdown tw-block tw-relative" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-bg-transparent tw-text-[#606060] tw-flex tw-justify-between tw-w-[150px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down tw-pb-0.5" })
], -1)
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = { class: "nav-item tw-pr-[45px] tw-pl-[30px]" }
const _hoisted_28 = { class: "nav-item dropdown" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " SIGN UP ", -1)
const _hoisted_30 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "visible-mobile" }
const _hoisted_33 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_34 = { class: "container-fluid" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-w-[100px]",
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNavDropdown",
  "aria-controls": "navbarNavDropdown",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_37 = {
  class: "collapse navbar-collapse",
  id: "navbarNavDropdown"
}
const _hoisted_38 = { class: "navbar-nav tw-text-left tw-mt-5" }
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = { class: "nav-item tw-mt-3" }
const _hoisted_41 = { class: "nav-item d-flex justify-content-left tw-mt-3" }
const _hoisted_42 = { class: "dropdown tw-block tw-relative" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-text-[#606060] tw-flex tw-justify-between tw-w-[120px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_44 = {
  class: "dropdown-menu",
  style: {"width":"150px !important","font-size":"12px"}
}
const _hoisted_45 = { class: "nav-item tw-mt-3" }
const _hoisted_46 = { class: "nav-item tw-mt-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle tw-text-[#606060] tw-font-bold tw-flex tw-gap-[19px]",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" SIGN UP"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_48 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  class: "container content-faqs",
  style: {"background-color":"#FFFFFF !important","padding-right":"100px","padding-left":"100px"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "faqs-tittle mt-4 pt-4" }, [
    /*#__PURE__*/_createElementVNode("span", null, " FREQUENTLY ASKED QUESTIONS ")
  ])
], -1)
const _hoisted_52 = { class: "mt-3 mb-4" }
const _hoisted_53 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_54 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_55 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_56 = {
  key: 0,
  class: "card card-body tw-text-justify tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Keep Realtors informed and updated on changes in the financial and economic landscape related to real estate activities. "),
  /*#__PURE__*/_createElementVNode("li", null, "Facilitate collaboration among various stakeholders in real estate, including those handling financial and economic information, as well as those involved in buying and selling properties, both in the residential and investment sectors."),
  /*#__PURE__*/_createElementVNode("li", null, "Provide Realtors with various calculation scenarios related to real estate, both in the residential and investment sectors."),
  /*#__PURE__*/_createElementVNode("li", null, "Transform Realtors into experts in real estate calculations in the fields of investment and residential properties."),
  /*#__PURE__*/_createElementVNode("li", null, "Open up global market opportunities for Realtors.")
], -1)
const _hoisted_58 = { class: "mb-4" }
const _hoisted_59 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_60 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_61 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_62 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_63 = { class: "mb-4" }
const _hoisted_64 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_65 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_66 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_67 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_68 = { class: "mb-2" }
const _hoisted_69 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_70 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_71 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_72 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Keep Realtors informed, especially regarding current market interest rates "),
  /*#__PURE__*/_createElementVNode("li", null, " Get closer to the client and conduct a deeper analysis of their situation and buying possibilities, through calculations based on their requirements in both the residential and investment sectors. "),
  /*#__PURE__*/_createElementVNode("li", null, " Create personalized videos, especially in the investment sector, to reach global audiences. "),
  /*#__PURE__*/_createElementVNode("li", null, " Achieve economic growth through the opportunities provided by the RealtorTools platform. ")
], -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "faqs-tittle mt-4 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", null, " RESIDENTIAL SCENARIOS ")
  ])
], -1)
const _hoisted_76 = { class: "mb-4" }
const _hoisted_77 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_78 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_79 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_80 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_81 = { class: "mb-4" }
const _hoisted_82 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_83 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_84 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_85 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_86 = { class: "mb-4" }
const _hoisted_87 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_88 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_89 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_90 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_91 = { class: "mb-4" }
const _hoisted_92 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_93 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_94 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_95 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_96 = { class: "mb-4" }
const _hoisted_97 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_98 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_99 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_100 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "faqs-tittle mt-4 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", null, " INVESTMENT SCENARIOS ")
  ])
], -1)
const _hoisted_102 = { class: "mb-4" }
const _hoisted_103 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_104 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_105 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_106 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_107 = { class: "mb-4" }
const _hoisted_108 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_109 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_110 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_111 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Flip Property Ready. "),
  /*#__PURE__*/_createElementVNode("li", null, " Flip As Is. "),
  /*#__PURE__*/_createElementVNode("li", null, " Passive Cash. "),
  /*#__PURE__*/_createElementVNode("li", null, " Passive Financial. "),
  /*#__PURE__*/_createElementVNode("li", null, " Short Term Financial "),
  /*#__PURE__*/_createElementVNode("li", null, " Short Term Cash. ")
], -1)
const _hoisted_113 = { class: "mb-4" }
const _hoisted_114 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_115 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_116 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_117 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_118 = { class: "mb-4" }
const _hoisted_119 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_120 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_121 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_122 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_123 = { class: "mb-4" }
const _hoisted_124 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_125 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_126 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_127 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_128 = { class: "mb-4" }
const _hoisted_129 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_130 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_131 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_132 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_133 = { class: "mb-4" }
const _hoisted_134 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_135 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_136 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_137 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_138 = { class: "mb-4" }
const _hoisted_139 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_140 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_141 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_142 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "faqs-tittle mt-4 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", null, " MARKETING ")
  ])
], -1)
const _hoisted_144 = { class: "mb-4" }
const _hoisted_145 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_146 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_147 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_148 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_149 = { class: "mb-4" }
const _hoisted_150 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_151 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_152 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_153 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Custom Content Production: One of the standout and innovative advantages of using RealtorTools is the ability to create personalized visual content, such as videos. These videos can be tailored to different focuses, whether specifically for residential clients, those interested in investments, or even a global audience interested in understanding how you operate within the system. Worldwide Virtual Conferences: The platform also offers the possibility to organize virtual conferences from anywhere in the world, using the account created on RealtorTools. This allows for a detailed explanation of how the desired results for clients are achieved. The geographical flexibility of these conferences enables reaching a global audience and provides an interactive learning experience. ")
], -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, " In-Person Events to Showcase Your Expertise: In addition to virtual options, RealtorTools allows you to organize in-person events to showcase your expertise in the field of real estate. These events can serve as a platform to demonstrate how you manage real estate operations, even in the most challenging situations and in the most successful investment scenarios. This demonstrates your real-time knowledge and skills. ")
], -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, " What does it mean to be considered a Realtor Expert? The designation of a \"Realtor Expert\" is awarded when someone demonstrates a deep understanding and mastery of all aspects of the real estate business. In this regard, the RealtorTools platform guides you through analysis, calculation, advisory, and the provision of information to clients in both the residential and investment sectors. Being a Realtor Expert means you have the ability to provide comprehensive and accurate guidance in all areas of this industry. ")
], -1)
const _hoisted_159 = [
  _hoisted_154,
  _hoisted_155,
  _hoisted_156,
  _hoisted_157,
  _hoisted_158
]
const _hoisted_160 = { class: "mb-4 pb-4" }
const _hoisted_161 = {
  class: "content-tittle d-flex",
  style: {"background-color":"#d5d7da !important","border-radius":"10px"}
}
const _hoisted_162 = {
  key: 0,
  src: _imports_3,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_163 = {
  key: 1,
  src: _imports_4,
  alt: "",
  style: {"padding-right":"30px"}
}
const _hoisted_164 = {
  key: 0,
  class: "card card-body tw-text-justify",
  style: {"border-color":"#FFFFFF"}
}
const _hoisted_165 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_167 = { class: "footer-realtors" }
const _hoisted_168 = { class: "container-fixed" }
const _hoisted_169 = { class: "row w-100" }
const _hoisted_170 = /*#__PURE__*/_createStaticVNode("<div class=\"img-brand col-xs-12 col-sm-12 col-md-3\"><img src=\"" + _imports_2 + "\" alt=\"\"></div><div class=\"contact col-xs-12 col-sm-12 col-md-3\"><ul class=\"\"><li class=\"tw-pb-3\"><a href=\"#\" class=\"fs-4 tw-font-semibold\">Contact</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/realtor\" class=\"tw-font-normal tw-text-[#dfdede] tw-ml-5\">Related to Realtor</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/mlo\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to MLO</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/title-company\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Title Company</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/inspector\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Inspectors</a></li></ul></div>", 2)
const _hoisted_172 = { class: "documents col-xs-12 col-sm-12 col-md-3" }
const _hoisted_173 = { class: "" }
const _hoisted_174 = { class: "tw-mb-4 tw-pt-3 fs-5 tw-font-semibold" }
const _hoisted_175 = /*#__PURE__*/_createStaticVNode("<li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/REALTORTOLLS-POLICY-ENGLISH.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Privacy Policy</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/TERMS-AND-USES.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Terms of use</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/COPYRIGHT-HOME.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Copyright</a></li>", 3)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, "© 2023 SOURCE RealtorTools, PBC. All rights reserved. Terms of Use | Privacy Policy Patents")
  ])
], -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "visible-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("© 2023 SOURCE RealtorTools, PBC. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" All rights reserved. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Terms of Use | Privacy Policy Patents")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                (_ctx.productSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_ctx.productSelected.toString() == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.productSelected.toString() == '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("nav", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("form", _hoisted_19, [
                  _createElementVNode("ul", _hoisted_20, [
                    _createElementVNode("li", _hoisted_21, [
                      _createVNode(_component_routerLink, { to: "/" }, {
                        default: _withCtx(() => [
                          _createTextVNode("HOME")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_routerLink, { to: "/target" }, {
                        default: _withCtx(() => [
                          _createTextVNode("TARGET")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("a", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("ul", _hoisted_26, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                            }, "RESIDENTIAL")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                            }, "INVESTMENT")
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_27, [
                      _createVNode(_component_routerLink, { to: "/loginusers" }, {
                        default: _withCtx(() => [
                          _createTextVNode("LOG IN ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("ul", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (role.name != 'ADMIN')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  id: "option",
                                  href: '/register?type=' + role.idRole
                                }, _toDisplayString(role.name), 9, _hoisted_31))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("nav", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("ul", _hoisted_38, [
              _createElementVNode("li", _hoisted_39, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HOME")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_40, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/target"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("TARGET")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_41, [
                _createElementVNode("a", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("ul", _hoisted_44, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                      }, "RESIDENTIAL")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                      }, "INVESTMENT")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_45, [
                _createVNode(_component_routerLink, {
                  class: "tw-text-[#606060]",
                  to: "/loginusers"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("LOG IN ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("ul", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (role.name != 'ADMIN')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "dropdown-item",
                            style: {"font-size":"12px"},
                            id: "option",
                            href: '/register?type=' + role.idRole
                          }, _toDisplayString(role.name), 9, _hoisted_49))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_53, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample1"
            }, " What is the RealtorTools platform? "),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_54))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_55))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createTextVNode(" The RealtorTools platform is a comprehensive tool designed for real estate professionals with the following objectives: "),
                _hoisted_57
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("p", _hoisted_59, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse1 && _ctx.toggleCollapse1(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample2"
            }, " Who are the system stakeholders? "),
            (!_ctx.isCollapsed1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_60))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_61))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, " The RealtorTools platform involves various stakeholders in real estate, such as Realtors, Mortgage Loan Originators (MLO), Title Companies or Escrow, and Inspectors. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("p", _hoisted_64, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse2 && _ctx.toggleCollapse2(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample3"
            }, " How does the system operate? "),
            (!_ctx.isCollapsed2)
              ? (_openBlock(), _createElementBlock("img", _hoisted_65))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed2)
              ? (_openBlock(), _createElementBlock("img", _hoisted_66))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Marginal actors (MLOs, title companies or escrow, and inspectors) play a crucial role in keeping the necessary variables updated for the calculations that Realtors perform in each system scenario. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("p", _hoisted_69, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse3 && _ctx.toggleCollapse3(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample4"
            }, " What are the advantages of using the RealtorTools platform? "),
            (!_ctx.isCollapsed3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_70))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_71))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_74))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_75,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("p", _hoisted_77, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse4 && _ctx.toggleCollapse4(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample5"
            }, " What is the goal of using the Budget scenario? "),
            (!_ctx.isCollapsed4)
              ? (_openBlock(), _createElementBlock("img", _hoisted_78))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed4)
              ? (_openBlock(), _createElementBlock("img", _hoisted_79))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, " The use of this scenario aims to assist individuals who rent or have a monthly budget for a property, including mortgage, taxes, and insurance. It provides an estimate of the property price they could afford based on their budget. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("p", _hoisted_82, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse5 && _ctx.toggleCollapse5(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample6"
            }, " What is the goal of using the DTI scenario? "),
            (!_ctx.isCollapsed5)
              ? (_openBlock(), _createElementBlock("img", _hoisted_83))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed5)
              ? (_openBlock(), _createElementBlock("img", _hoisted_84))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, " This scenario seeks to provide an estimate of the loan amount a customer could obtain without affecting their credit or requiring a formal pre-approval. It is important to remember that this estimate may vary due to factors such as the customer's credit score and history. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("p", _hoisted_87, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse6 && _ctx.toggleCollapse6(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample7"
            }, " What is the goal of using the Mortgage Loan Monthly Payment scenario? "),
            (!_ctx.isCollapsed6)
              ? (_openBlock(), _createElementBlock("img", _hoisted_88))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed6)
              ? (_openBlock(), _createElementBlock("img", _hoisted_89))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, " This scenario allows for the calculation of monthly mortgage payments with updated interest rates. If the customer's information is accurate, the results will be precise, including factors such as credit score. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("p", _hoisted_92, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse7 && _ctx.toggleCollapse7(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample8"
            }, " What is the goal of using the Total Monthly Payment scenario? "),
            (!_ctx.isCollapsed7)
              ? (_openBlock(), _createElementBlock("img", _hoisted_93))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed7)
              ? (_openBlock(), _createElementBlock("img", _hoisted_94))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_95, " This scenario calculates monthly payments for the mortgage, taxes, insurance, and, if applicable, association fees. It also allows the customer to see how a 20% down payment and avoiding MIP can impact the monthly payment. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("p", _hoisted_97, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse8 && _ctx.toggleCollapse8(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample9"
            }, " What is the goal of using the Cash Monthly Payment scenario? "),
            (!_ctx.isCollapsed8)
              ? (_openBlock(), _createElementBlock("img", _hoisted_98))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed8)
              ? (_openBlock(), _createElementBlock("img", _hoisted_99))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed8)
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, " This scenario calculates cash monthly payments, including taxes, insurance, and, if applicable, association fees "))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_101,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("p", _hoisted_103, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse9 && _ctx.toggleCollapse9(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample10"
            }, " What is the concept behind the use of investment scenarios? "),
            (!_ctx.isCollapsed9)
              ? (_openBlock(), _createElementBlock("img", _hoisted_104))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed9)
              ? (_openBlock(), _createElementBlock("img", _hoisted_105))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed9)
            ? (_openBlock(), _createElementBlock("div", _hoisted_106, " The main concept is to demonstrate to the client how, through calculations in any of the investment scenarios, they can obtain estimates of the profits they could achieve by investing in a specific property. This helps to minimize investment risk. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("p", _hoisted_108, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse10 && _ctx.toggleCollapse10(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample11"
            }, " What are the types of real estate investments that can be calculated? "),
            (!_ctx.isCollapsed10)
              ? (_openBlock(), _createElementBlock("img", _hoisted_109))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed10)
              ? (_openBlock(), _createElementBlock("img", _hoisted_110))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _createTextVNode(" The types of investments that can be calculated include: "),
                _hoisted_112
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("p", _hoisted_114, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse11 && _ctx.toggleCollapse11(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample12"
            }, " What is the goal of using the Flip Property Ready scenario? "),
            (!_ctx.isCollapsed11)
              ? (_openBlock(), _createElementBlock("img", _hoisted_115))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed11)
              ? (_openBlock(), _createElementBlock("img", _hoisted_116))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed11)
            ? (_openBlock(), _createElementBlock("div", _hoisted_117, " This scenario focuses on county auction properties and calculates the potential profit if the property is delivered, ready to be inhabited, before selling it. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("p", _hoisted_119, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse12 && _ctx.toggleCollapse12(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample13"
            }, " What is the goal of using the Flip As Is scenario? "),
            (!_ctx.isCollapsed12)
              ? (_openBlock(), _createElementBlock("img", _hoisted_120))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed12)
              ? (_openBlock(), _createElementBlock("img", _hoisted_121))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed12)
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, " This scenario also focuses on county auction properties but does not assume that the property is in optimal condition to be inhabited. The buyers will be responsible for fixing the house. In the calculations, the selling price of the property will decrease by the estimated cost of property repairs. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("p", _hoisted_124, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse13 && _ctx.toggleCollapse13(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample14"
            }, " What is the goal of using the Passive Cash scenario? "),
            (!_ctx.isCollapsed13)
              ? (_openBlock(), _createElementBlock("img", _hoisted_125))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed13)
              ? (_openBlock(), _createElementBlock("img", _hoisted_126))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed13)
            ? (_openBlock(), _createElementBlock("div", _hoisted_127, " To search for properties and, through economic and financial evaluation, determine the profit that could be achieved in the investment when the purchase is made in cash. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("p", _hoisted_129, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse14 && _ctx.toggleCollapse14(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample15"
            }, " What is the goal of using the Passive Investment scenario? "),
            (!_ctx.isCollapsed14)
              ? (_openBlock(), _createElementBlock("img", _hoisted_130))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed14)
              ? (_openBlock(), _createElementBlock("img", _hoisted_131))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed14)
            ? (_openBlock(), _createElementBlock("div", _hoisted_132, " To search for properties and, through economic and financial evaluation, determine the profit that could be achieved in the investment with financing "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_133, [
          _createElementVNode("p", _hoisted_134, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse15 && _ctx.toggleCollapse15(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample16"
            }, " What is the goal of using the Short-Term Financial scenario? "),
            (!_ctx.isCollapsed15)
              ? (_openBlock(), _createElementBlock("img", _hoisted_135))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed15)
              ? (_openBlock(), _createElementBlock("img", _hoisted_136))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed15)
            ? (_openBlock(), _createElementBlock("div", _hoisted_137, " To search for properties that fit a short-term strategy and, through economic and financial evaluation, determine the profit when the property is purchased with financing. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_138, [
          _createElementVNode("p", _hoisted_139, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse16 && _ctx.toggleCollapse16(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample17"
            }, " What is the goal of using the Short-Term Cash scenario? "),
            (!_ctx.isCollapsed16)
              ? (_openBlock(), _createElementBlock("img", _hoisted_140))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed16)
              ? (_openBlock(), _createElementBlock("img", _hoisted_141))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed16)
            ? (_openBlock(), _createElementBlock("div", _hoisted_142, " To search for properties that fit a short-term strategy and, through economic and financial evaluation, determine the profit when the property is purchased in cash. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_143,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_144, [
          _createElementVNode("p", _hoisted_145, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse17 && _ctx.toggleCollapse17(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample18"
            }, " How is marketing personalized with the RealtorTools platform? "),
            (!_ctx.isCollapsed17)
              ? (_openBlock(), _createElementBlock("img", _hoisted_146))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed17)
              ? (_openBlock(), _createElementBlock("img", _hoisted_147))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed17)
            ? (_openBlock(), _createElementBlock("div", _hoisted_148, " When a Realtor creates an account on RealtorTools, they obtain their own real estate business space that they can personalize according to their needs. This web platform allows them to identify themselves with their name and business information, which they can then share on their social networks and other spaces. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_149, [
          _createElementVNode("p", _hoisted_150, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse18 && _ctx.toggleCollapse18(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample19"
            }, " What is the advantage and innovation of marketing through the RealtorTools platform? "),
            (!_ctx.isCollapsed18)
              ? (_openBlock(), _createElementBlock("img", _hoisted_151))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed18)
              ? (_openBlock(), _createElementBlock("img", _hoisted_152))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed18)
            ? (_openBlock(), _createElementBlock("div", _hoisted_153, _hoisted_159))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("p", _hoisted_161, [
            _createElementVNode("a", {
              class: "btn btn-collapse w-100 d-flex justify-content-between fw-medium",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse19 && _ctx.toggleCollapse19(...args))),
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "collapseExample20"
            }, " ADDITION OF CUSTOMIZED OPTIONS "),
            (!_ctx.isCollapsed19)
              ? (_openBlock(), _createElementBlock("img", _hoisted_162))
              : _createCommentVNode("", true),
            (_ctx.isCollapsed19)
              ? (_openBlock(), _createElementBlock("img", _hoisted_163))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isCollapsed19)
            ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                _createTextVNode(" The \"Add Custom Options\" feature means that platform users can request the inclusion of additional features in their accounts according to their specific needs. "),
                _hoisted_165,
                _createTextVNode(" This provides them with the flexibility to customize their experience on RealtorTools based on their individual requirements, allowing for a more tailored and effective use of the platform. "),
                _hoisted_166,
                _createTextVNode(" To request these additions, they can do so through the \"Requirements\" section. ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_167, [
      _createElementVNode("div", _hoisted_168, [
        _createElementVNode("div", _hoisted_169, [
          _hoisted_170,
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("ul", _hoisted_173, [
              _createElementVNode("li", _hoisted_174, [
                _createVNode(_component_routerLink, { to: "/faqs" }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQs")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_175
            ])
          ])
        ]),
        _hoisted_178,
        _hoisted_179,
        _hoisted_180
      ])
    ])
  ], 64))
}